// extracted by mini-css-extract-plugin
export default {"footer":"Lor_footer__qzRnn"};